import React from 'react';
import { List } from '@material-ui/core';
import { isNumber } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { usePriceService } from '../../utils/hooks/priceService';
import { ImageCard } from '../ImageCard';
import { ListItemDense } from '../List';
import { Typography } from '../Typography';
import { OrderLine } from './types';
import { PaddedBoldTypography } from './style';

const BillDetail = (orderLine: OrderLine) => {
    const {
        product: { name, tax: productTax },
        quantity,
        price,
        unitPrice,
        discountedPrice,
        discountedUnitPrice
    } = orderLine;

    const { priceService } = usePriceService();
    const { t } = useTranslation();

    const finalTax = orderLine.tax ? orderLine.tax.rate : productTax.rate;
    const totalPrice = isNumber(discountedPrice) ? discountedPrice : price;
    const localizedTotalPrice = priceService.toLocaleString(totalPrice);
    const localizedUnitPrice = priceService.toLocaleString(discountedUnitPrice || unitPrice);

    const withoutTax = priceService.deductTax(totalPrice, finalTax);
    const withoutTaxString = priceService.toLocaleString(withoutTax);
    const taxRate = `${finalTax}%`;

    return (
        <ImageCard>
            <Typography variant='h6' noWrap>{name}</Typography>
            <List dense>
                <ListItemDense>
                    <PaddedBoldTypography variant='body2'>{t('price per piece:')}</PaddedBoldTypography>
                    <Typography variant='body2'>{localizedUnitPrice}</Typography>
                </ListItemDense>
                <ListItemDense>
                    <PaddedBoldTypography variant='body2'>{t('Amount:')}</PaddedBoldTypography>
                    <Typography variant='body2'>{quantity}</Typography>
                </ListItemDense>
                <ListItemDense>
                    <PaddedBoldTypography variant='body2'>{t('Tax:')}</PaddedBoldTypography>
                    <Typography variant='body2'>{taxRate}</Typography>
                </ListItemDense>
                <ListItemDense>
                    <PaddedBoldTypography variant='body2'>{t('price without tax:')}</PaddedBoldTypography>
                    <Typography variant='body2'>{withoutTaxString}</Typography>
                </ListItemDense>
                <ListItemDense>
                    <PaddedBoldTypography variant='body2'>{t('overall price:')}</PaddedBoldTypography>
                    <Typography variant='body2'>{(localizedTotalPrice)}</Typography>
                </ListItemDense>
            </List>
        </ImageCard>
    );
};

export default BillDetail;
